/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { denormalizeConversationsByActiveClinic } from 'Selectors/webChat/consults';
import { CONSULT_TYPE_CHAT } from 'Constants/consults';
import useDoctor from 'Hooks/teleconsult/useDoctor';
import { minimumToBubble, bubblesClear } from 'Redux/modules/webChat/commons/actions';
import { messageMarkAsRead, bubblesRemove } from 'Redux/modules/webChat/actions';
import { updateEntities } from 'Redux/modules/entities/actions';
import { WEBCHAT } from 'Constants/normalize-module';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { getBubblesChat } from 'Selectors/webChat/common';

import PersonAvatar from '../../Sidebar/List/ChatListGroup/PersonAvatar';

import Messages from './Messages';
import css from './WrapMessage.less';

const KEY_UNREAD_MESSAGE = 'unreadCount';

const WrapMessage = props => {
  const dispatch = useDispatch();
  const { data: doctorData } = useDoctor();
  const bubbles = useSelector(state => getBubblesChat(state, state.webChat.commons.bubbles));

  const conversations = useSelector(state => denormalizeConversationsByActiveClinic(state));

  const readMessage = async (conversationId, consultId, consultType = CONSULT_TYPE_CHAT) => {
    const state = {
      action: 'read',
      user: doctorData.userUuid,
      metadata: {
        consultId,
        conversationId,
        consultType,
      },
    };
    const body = {
      participant: {
        [KEY_UNREAD_MESSAGE]: 0,
      },
    };
    await dispatch(messageMarkAsRead(state));
    await dispatch(updateEntities(WEBCHAT, 'conversation', conversationId, body));
  };

  const unreadMessageGroups = conversations.filter(
    e => !!e?.participant?.unreadCount && e?.participant?.unreadCount > 0,
  );

  const handleBubbleChatToMini = group => {
    dispatch(minimumToBubble(group.id));
    readMessage(group.id, group.latestConsult.id);
  };
  const handleClear = () => {
    dispatch(bubblesClear());
  };
  const handleCloseBubble = (e, id) => {
    e.stopPropagation();
    dispatch(bubblesRemove(id));
  };
  return (
    <div className={css.wrap}>
      <div className={css.miniChat}>
        {bubbles.length > 3 && (
          <Popup
            inverted
            position="left center"
            content="Close all"
            trigger={
              <div className={css.removeIcon}>
                <Icon onClick={handleClear} name="close" />
              </div>
            }
          />
        )}
        {bubbles?.map(
          item =>
            item?.isMinimum && (
              <Popup
                inverted
                key={item.id}
                position="left center"
                content={item?.latestConsult?.patient?.fullName}
                trigger={
                  <div className={css.miniItem} onClick={() => handleBubbleChatToMini(item)}>
                    <PersonAvatar data={item?.latestConsult?.patient} />
                    {unreadMessageGroups.find(e => e.id === item.id)?.participant.unreadCount >
                      0 && (
                      <Label
                        circular
                        style={{ backgroundColor: '#30a1f9', color: 'white' }}
                        className={css.unreadNum}
                        floating>
                        {unreadMessageGroups.find(e => e.id === item.id)?.participant.unreadCount <
                        99
                          ? unreadMessageGroups.find(e => e.id === item.id)?.participant.unreadCount
                          : '99+'}
                      </Label>
                    )}
                    {item?.latestConsult?.patient.id !== item?.latestConsult?.forPatient.id && (
                      <PersonAvatar
                        data={item?.latestConsult?.forPatient}
                        parentData={item?.latestConsult?.patient}
                      />
                    )}
                    <Popup
                      content="Close"
                      inverted
                      size="mini"
                      trigger={
                        <Label
                          circular
                          style={{ backgroundColor: 'gray', color: 'white' }}
                          className={css.closeBubble}
                          floating
                          onClick={e => handleCloseBubble(e, item.id)}>
                          <Icon name="close" color="black" />
                        </Label>
                      }
                    />
                  </div>
                }
              />
            ),
        )}
      </div>
      {bubbles
        ?.filter(e => !e.isMinimum)
        ?.map(bubble => (
          <div key={bubble.id} className={css.chatWrap}>
            <Messages
              {...props}
              isMinimize
              conversationActive={bubble}
              readMessage={readMessage}
              consult={bubble.latestConsult}
            />
          </div>
        ))}
    </div>
  );
};

export default WrapMessage;
